import { render, staticRenderFns } from "./user_limit.vue?vue&type=template&id=67f76f70&"
import script from "./user_limit.vue?vue&type=script&lang=js&"
export * from "./user_limit.vue?vue&type=script&lang=js&"
import style0 from "./user_limit.vue?vue&type=style&index=0&id=67f76f70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports